// extracted by mini-css-extract-plugin
export default {"shadowed":"BaseLayout_shadowed__uMXO+","dark":"BaseLayout_dark__jbUSN","light":"BaseLayout_light__7fqY4"};